import useCompetitorsStore from 'store/useCompetitorsStore';
import StatCard from './StatCard';

const CompetitorOverviewGrid = () => {
    const { selectedSavedCompetitor } = useCompetitorsStore();
    return (
        <div className="relative">
            <div className="font-medium leading-[24px] pb-[10px]" data-cy="right-panel-competitor-overview-title">
                Collaboration Partner overview
            </div>

            <div className="grid md:grid-cols-3 grid-cols-1 gap-[10px] p-[5px] rounded-[10px] bg-white">
                <StatCard
                    label="Total Listings"
                    value={selectedSavedCompetitor?.propertyCount || 0}
                    dataCyLabel="right-panel-total-listings-label"
                    dataCyValue="right-panel-total-listings-value"
                />
                <StatCard
                    label="New Listings"
                    value={selectedSavedCompetitor?.propertiesAddedLast24Hours || 0}
                    dataCyLabel="right-panel-new-listings-label"
                    dataCyValue="right-panel-new-listings-value"
                />
                <StatCard
                    label="Property no longer listed"
                    value={selectedSavedCompetitor?.propertiesOff || 0}
                    dataCyLabel="right-panel-properties-off-label"
                    dataCyValue="right-panel-properties-off-value"
                />
            </div>
        </div>
    );
};

export default CompetitorOverviewGrid;
